<template>
        <el-dialog title="Credit Card" :visible.sync="showPopup" class="my-dialog-class" >
        <el-form label-position="top" :inline="false" :rules="rules" label-width="100%"  :model='selectedObject'  ref='my-form' @submit.prevent="save" v-loading="loadingVisible" >
            <el-row :gutter="15" >
                <el-col :md='8'>
                    <el-form-item label='User' >
                     <el-select v-model='selectedObject.IdUser'  class='full-width'>        
                         <el-option v-for='item in Info.users' :key="'users' + item.Id" :label='item.FirstName' :value='item.Id'></el-option>
                    </el-select>
                </el-form-item>
                </el-col>
                <el-col :md='16'>
                    <el-form-item label='Number' >
                        <el-input  class='full-width' v-model='selectedObject.Number' />
                    </el-form-item>
                </el-col>
                
                <el-col :md='8'>
                    <el-form-item label='Expires' >
                        <el-input  class='full-width' v-model='selectedObject.Expires' />
                    </el-form-item>
                </el-col>
                <el-col :md='8'>
                    <el-form-item label='CVV' >
                        <el-input  class='full-width' v-model='selectedObject.CVV' />
                    </el-form-item>
                </el-col>
                <el-col :md='8'>
                    <el-form-item label='Name on card' >
                        <el-input  class='full-width' v-model='selectedObject.Name' />
                    </el-form-item>
                </el-col>            
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer" >
            <el-button @click="showPopup=false"     > Renunta  </el-button>
            <el-button type="primary" @click="save" > Salveaza </el-button>
        </span>
    </el-dialog>
</template>

<script>
    import settings from "@/backend/LocalSettings";
    import BasePage from '@/pages/BasePage';

    export default {
        name: "Creditcard_dialog",
        extends: BasePage,
        data () {
            return {
                baseUrl :'',
                showPopup: false,
                mode: 'add',
                selectedObject: {
                    IdUser: '', Number: '' , Expires: '' , CVV: '' , Name: ''
                },
                Info:{
                    users:[]
                },
                rules: {
                    //   Nume: [ { required: true, message: "Campul este obligatoriu" } ]
                    Number: [ { required: true, message: 'Campul este obligatoriu' } ], 
                    Expires: [ { required: true, message: 'Campul este obligatoriu' } ], 
                    CVV: [ { required: true, message: 'Campul este obligatoriu' } ], 
                    Name: [ { required: true, message: 'Campul este obligatoriu' } ], 
                }
            }
        },
        methods: {
            show_me: async function( id ) {
                this.showPopup        = true;
                if( id == null )
                {
                    this.mode = "add";
                }
                else
                {
                    this.mode             = "edit";
                    var            result = await this.post("creditcard/get_info_item_dialog", { id: id } );
                    this.selectedObject   = result.Item;
                }
            },
            async get_info(){
                var response = await this.post("creditcard/get_info_for_dialog" );
                this.Info.users = response.users;
            },
            save: async function() {
                this.$refs['my-form'].validate( async(valid) => {
                    if (valid)
                    {
                        await this.post("creditcard/save", { mode: this.mode, object: this.selectedObject } );
                        this.showPopup = false;
                        this.$emit("save");
                    }
                });
            }
        },
        mounted: function() {
            this.baseUrl = settings.BASE_URL;
            this.get_info();
        }
    };
</script>

<style lang="less" scoped>
    .full-width {
        width: 100%;
    }

</style>